import { forwardRef, HTMLAttributes, Ref, useEffect, useRef } from 'react';

import { IComponent } from '../../models/components.models';
import { useClassNames } from '../../utils/hooks';
import { ILogStyles, logStylesDefault } from './Log.styles';
interface ILogClassNames {
  root: string;
}

export type LogLine = {
  data: string;
};

export interface LogProps extends IComponent<ILogStyles>, HTMLAttributes<HTMLDivElement> {
  log: Array<LogLine>;
}

export const Log = forwardRef((props: LogProps, ref: Ref<HTMLDivElement>) => {
  const { styles, log, className, ...elementProps } = props;
  const logEndRef = useRef<any>(null);
  const scrollToBottom = () => {
    logEndRef.current?.scrollIntoView();
  };
  useEffect(() => {
    scrollToBottom();
  }, [log]);
  const classNames = useClassNames<ILogStyles, ILogClassNames>('Log', logStylesDefault, styles, className);

  return (
    <div {...elementProps} ref={ref} className={classNames.root} data-test={props['data-test'] || 'log'}>
      {log?.map((message) => `${message?.data}`)}
      <div ref={logEndRef} />
    </div>
  );
});
